// extracted by mini-css-extract-plugin
export default {"text":"uydbzPbZgQ5vfPhXudcW"};